import { pdf, Document, Page, Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import Swal from "sweetalert2";
import logotp_ma from "../../../assets/img/logos/logo Total Protect.png";

/* PDF STYLES */
/* PDF STYLES */
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 9,
    },

    title: {
        fontSize: 18,
        marginBottom: 6,
        fontWeight: "bold",
        textAlign: "center",
    },

    subtitle: {
        fontSize: 10,
        marginBottom: 12,
        textAlign: "center",
        color: "#555",
    },

    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 6,
    },

    statusOk: { color: "#2e7d32", fontWeight: "bold" },
    statusWarn: { color: "#ed6c02", fontWeight: "bold" },
    statusRisk: { color: "#d32f2f", fontWeight: "bold" },

    content: {
        flexDirection: "row",
        gap: 10,
    },

    left: {
        width: "35%",
    },

    right: {
        width: "65%",
    },

    label: {
        fontSize: 8,
        color: "#666",
    },

    value: {
        fontSize: 9,
        marginBottom: 4,
    },

    imageGrid: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 6,
    },

    image: {
        width: "85%",
        height: "100%",
        maxHeight: "300px",
        objectFit: "cover",
        borderRadius: 4,
        alignSelf: "flex-end",
    },

    noEvidence: {
        fontSize: 9,
        fontStyle: "italic",
        color: "#999",
    },

    dateHeader: {
        fontSize: 12,
        fontWeight: "bold",
        marginTop: 14,
        marginBottom: 10,
        backgroundColor: "#f2f2f2",
        paddingVertical: 6,
        paddingHorizontal: 8,
        borderRadius: 4,
    },

    card: {
        border: "1 solid #ddd",
        borderRadius: 6,
        padding: 10,
        marginBottom: 12,
        breakInside: "avoid", // 👈 CLAVE
    },
    topHeader: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
    },

    titleContainer: {
        flex: 1,
        textAlign: "center",
    },

    logo: {
        width: 150,      // ajusta según tu logo
        height: 50,
        objectFit: "contain",
    },

});

/* PDF COMPONENT */
const ChecklistPDF = ({ data }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.topHeader}>
                {/* Espacio vacío para balancear */}
                <View style={{ width: 60 }} />

                {/* Título centrado */}
                <View style={styles.titleContainer}>
                    <Text style={styles.title}>Reporte Checklist de Dispositivos</Text>
                    <Text style={styles.subtitle}>
                        Rango: {data.range} | Total: {data.total}
                    </Text>
                </View>

                {/* Logo esquina derecha */}
                <Image src={logotp_ma} style={styles.logo} />
            </View>

            {data.fechasOrdenadas.map((fecha,) => (
                <View key={fecha}>
                    {data.groupedByDate[fecha].map((item, index) => (
                        <View key={item.check_id} wrap={false}>
                            {/* Solo muestra el header en la primera tarjeta */}
                            {index === 0 && (
                                /* ENCABEZADO DE FECHA */
                                <Text style={styles.dateHeader}>📅 {fecha}</Text>
                            )}

                            {/* Card */}
                            <View style={styles.card}>
                                {/* HEADER */}
                                <View style={styles.header}>
                                    <Text>
                                        MDVR: {item.mdvr}
                                    </Text>
                                    <Text
                                        style={
                                            item.estatus_general === "Correcto"
                                                ? styles.statusOk
                                                : item.estatus_general === "Riesgo"
                                                    ? styles.statusRisk
                                                    : styles.statusWarn
                                        }
                                    >
                                        {item.estatus_general}
                                    </Text>
                                </View>

                                {/* BODY */}
                                <View style={styles.content}>
                                    <View style={styles.left}>
                                        <Text style={styles.label}>Cliente</Text>
                                        <Text style={styles.value}>{item.cliente}</Text>
                                        <Text style={styles.label}>Responsable</Text>
                                        <Text style={styles.value}>{item.responsable}</Text>
                                        <Text style={styles.label}>GPS / Grabación</Text>
                                        <Text style={styles.value}>
                                            {item.gps ? "Sí" : "No"} | {item.grabacion ? "Sí" : "No"}
                                        </Text>
                                        <Text style={styles.label}>Cámaras:</Text>
                                        <Text style={styles.value}>
                                            {item.cam1} | {item.cam2} | {item.cam3} | {item.cam4}
                                        </Text>
                                    </View>
                                    <View style={styles.right}>
                                        {item.evidencias.length > 0 ? (
                                            <Image src={item.evidencias[0]} style={styles.image} />
                                        ) : (
                                            <Text style={styles.noEvidence}>Sin evidencia</Text>
                                        )}
                                    </View>
                                </View>
                            </View>
                        </View>
                    ))}

                </View>
            ))}

        </Page>
    </Document>
);

/* Función para generar PDF */
export const generateChecklistPDF = async (fechaInicio, fechaFin, cliente, getCheckListDevice, postDownloadEvidence) => {
    try {
        // 1️⃣ Traer datos
        const checklist = await getCheckListDevice(fechaInicio, fechaFin, cliente);

        // 2️⃣ Traer evidencias
        const resultado = await Promise.all(
            checklist.resultado.map(async (item) => {
                const img = await postDownloadEvidence(item.check_id);
                return { ...item, evidencias: img ? [img] : [] };
            })
        );

        // 3️⃣ AGRUPAR POR FECHA
        const groupedByDate = resultado.reduce((acc, item) => {
            if (!acc[item.fecha]) acc[item.fecha] = [];
            acc[item.fecha].push(item);
            return acc;
        }, {});

        // 4️⃣ ORDENAR FECHAS
        const fechasOrdenadas = Object.keys(groupedByDate).sort((a, b) => {
            return new Date(b.replace(/\//g, "-")) - new Date(a.replace(/\//g, "-"));
        });

        // 5️⃣ DATA FINAL
        const data = {
            ...checklist,
            groupedByDate,
            fechasOrdenadas,
        };


        // 3️⃣ Generar PDF y abrir en nueva pestaña
        const blob = await pdf(<ChecklistPDF data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");

    } catch (error) {
        console.error("Error generando PDF", error);
        Swal.fire({ title: "Error", text: "No se pudo generar el PDF", icon: "error" });
    }
};
